import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Container,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

const sections = [
  { title: "Home", path: "/" },
  { title: "Activities", path: "/activities/" },
  { title: "Projects", path: "/project/" },
  { title: "Programs", path: "/programs/" },
  { title: "News", path: "/news/" },
  { title: "Your Voice", path: "/report-violations/" },
  { title: "About Us", path: "/about/" },
];

const NavBar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const closeDrawerOnClick = () => {
    setMobileOpen(false); // Closes the drawer when an item is clicked
  };

  const drawer = (
    <Box
      sx={{
        width: 250,
        backgroundColor: "#0B0F19",
        height: "100%",
        paddingTop: "20px",
        "& .MuiListItem-root": {
          transition: "background-color 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: "#1A2E55",
          },
        },
      }}
    >
      <List>
        {sections.map((section) => (
          <ListItem
            button
            key={section.title}
            component={NavLink}
            to={section.path}
            onClick={closeDrawerOnClick} // This ensures the drawer closes when an item is clicked
            sx={{
              textAlign: "center",
              color: "#FFFFFF",
              textTransform: "uppercase",
              padding: "10px 20px",
              "&.active": {
                color: "#00BFFF",
                borderBottom: "2px solid #00BFFF",
              },
            }}
          >
            <ListItemText primary={section.title} />
          </ListItem>
        ))}
        <ListItem
          button
          component={NavLink}
          to="/contact"
          onClick={closeDrawerOnClick} // This ensures the drawer closes when an item is clicked
          sx={{
            textAlign: "center",
            color: "#FFFFFF",
            padding: "12px 24px",
            backgroundColor: "#10a7e0",
            borderRadius: "6px",
            margin: "20px auto",
            width: "80%",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#10a7e0",
              transform: "scale(1.05)",
            },
          }}
        >
          Contact
        </ListItem>
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: "#0B0F19",
          padding: "0 20px",
          boxShadow: "none",
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#FFFFFF",
                letterSpacing: "1px",
                fontSize: { md: "12px", lg: "16px" },
              }}
            >
              SHALL
            </Typography>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                flexGrow: 1,
              }}
            >
              {sections.map((section) => (
                <Button
                  key={section.title}
                  component={NavLink}
                  to={section.path}
                  sx={{
                    fontSize: { md: "8px", lg: "15px" },
                    color: "#FFFFFF",
                    margin: "0 16px",
                    "&.active": {
                      color: "#00BFFF",
                      borderBottom: "2px solid #00BFFF",
                    },
                    "&:hover": { color: "#00BFFF" },
                  }}
                >
                  {section.title}
                </Button>
              ))}
            </Box>
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { xs: "block", md: "none" }, color: "#FFFFFF" }}
            >
              <MenuIcon />
            </IconButton>
            <Button
              component={NavLink}
              to="/contact"
              variant="contained"
              sx={{
                fontSize: { md: "8px", lg: "15px" },
                backgroundColor: "#10a7e0",
                color: "#FFFFFF",
                borderRadius: "6px",
                display: { xs: "none", md: "block" },
                "&:hover": {
                  backgroundColor: "#10a7e0",
                  transform: "scale(1.05)",
                },
              }}
            >
              Contact
            </Button>
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
        {drawer}
      </Drawer>
    </>
  );
};

export default NavBar;
